import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { StatusCardKey } from "../../pages/app/provider/dashboard/constant/dashboard-constant";
import { DashboardControllerApi } from "../../services";
import { getConfigObject, useBaseData } from "../../utils/utils";

interface Props {
  xTENANTID?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useDashboardStatusCount = ({
  xTENANTID,
}: Props): useBaseData<Record<StatusCardKey, number>> =>
  useQuery({
    queryKey: ["dashboard-status-count", xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!xTENANTID,
    queryFn: async () =>
      await new DashboardControllerApi(getConfigObject())
        .getDashboardCounts(xTENANTID)
        .then((res) => res?.data),
  });
